import { makeStyles } from "@material-ui/core"

const drawerWidth = 350

export default makeStyles(() => ({
    appMenu: {
        width: "100%"
    },
    navList: {
        width: drawerWidth
    },
    menuItem: {
        width: drawerWidth
    },
    menuItemIcon: {
        color: "#97c05c"
    }
}))
